import * as Forms from '../../forms';

window.Reverb = window.Reverb || {};

// Used on accept/offer/reject lightboxes in dashboard
Reverb.SubmitOfferLightbox = (function () {
  function init() {
    bindOfferSubmit();
  }

  function bindOfferSubmit() {
    $(document).on('ajax:complete', '[data-offersubmit] form', closeDialog);
    $(document).on('ajax:success', '[data-offersubmit] form', offerSubmitSuccess);
    $(document).on('ajax:error', '[data-offersubmit] form', offerSubmitError);
  }

  function closeDialog() {
    $.fancybox.close();
  }

  function offerSubmitSuccess(e, data) {
    Reverb.UI.displayMessageThenContent(data.dom_id, data.message, data.template, 1500);
    decrementBadges(data.product_owner);
  }

  function offerSubmitError(e, data) {
    const response = $.parseJSON(data.responseText);
    const $form = $(e.target);
    Forms.reEnableDisabledFormSubmit($form);
    Reverb.UI.flashError(response.error);
  }

  function decrementBadges(product_owner) {
    Reverb.Badges.decrementBadge('total_active_offers_badge');
    if (product_owner) {
      Reverb.Badges.decrementBadge('seller_active_offers_badge');
    } else {
      Reverb.Badges.decrementBadge('buyer_active_offers_badge');
    }
  }

  return {
    init,
    offerSubmitSuccess,
  };
}());

$(() => {
  Reverb.SubmitOfferLightbox.init();
});
